export default "__VITE_ASSET__1bc9cf1c__"